import { Dictionary } from './ga-tagging.types';

export type RedeyeTags = Dictionary<string | string[] | undefined | null>;
export type RedeyeTagsFiltered = Dictionary<string | string[]>;
